import './App.css';
import {Button, Typography} from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Header from './Components/Header';
import Name from './Components/Name';
import Repo from './Components/Repo';

import { HomePage } from "./containers/HomePage"
import About from './Components/About';
import Portfolio from './Components/Portfolio';
import Particle from "./Components/Particle";
import Particles from 'react-particles-js';
import particlesConfig from './particlesjs-config.js';

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

function App() {
  const classes = useStyles();
  console.log(particlesConfig);
  return (
    <div className={classes.root}>
      {/* <div style={{ position: 'absolute'}}>
        <Particles height="100px" width="100px" params={particlesConfig} />
      </div> */}
      {/* <HomePage /> */}
      {/* <Header />
      <Name />
      <About />
      <Repo /> */}
      {/* <div>Hi</div> */}
      {/* <Particles height="100vh" width="100vw" params={particlesConfig} /> */}
      {/* // <Particle class="particle-canvas"/>
      // <div
      //     style={{
      //       position: "absolute",
      //       top: 0,
      //       left: 0,
      //       width: "100%",
      //       height: "100%"
      //     }}
      //   >
      //   <Portfolio />
        
      // </div> */}
      
      <Router>
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/Portfolio/" exact render={(props) => <Portfolio {...props}/>}/>
        </Switch>
      </Router>
      {/*
        <HomePage />
      <Header />
      <Name />
      <About />
      <Repo />
      <Portfolio />*/}
    </div>
  );
}

export default App;